import { z } from 'zod';

export const displayUnitSchema = z.enum(['energy', 'dollars']);
export type DisplayUnit = z.infer<typeof displayUnitSchema>;

export type WeatherOverlayType = 'cloudCover' | 'temperature' | 'conditions';
